/**
 * @file Enum presenting the supported values of the Request.Type property.
 * @author Tom Verschoore de la Houssaije.
 */
/**
 * Enum presenting the supported values of the Request.Type property.
 * @export
 * @enum {string}
 */
export var RequestTypes;
(function (RequestTypes) {
    /**
     * Representing a Request where the receiver is asked to take over the Assignment indicated by the Request subject.
     */
    RequestTypes["ReassignAssignment"] = "REASSIGN-ASSIGNMENT";
    /**
     * Representing a Request where the receiver is asked to take over the Attendant indicated by the Request subject.
     */
    RequestTypes["ReassignAttendant"] = "REASSIGN-ATTENDANT";
    /**
     * Representing a Request where the receiver is asjed to take over an entire day.
     */
    RequestTypes["ReassignDay"] = "REASSIGN-DAY";
    /**
     * Representing a Request where the Resources of the Assignments,
     * indicated by the Request's subject and target,
     * are asked to swap Assignments.
     */
    RequestTypes["ExchangeAssignment"] = "EXCHANGE-ASSIGNMENT";
    /**
     * Representing a Request where the Resources of the Attendants,
     * indicated by the Request's subject and target,
     * are asked to swap Attendants.
     */
    RequestTypes["ExchangeAttendant"] = "EXCHANGE-ATTENDANT";
    /**
     * Representing a Request where the Resources,
     * indicated by the Request's subject and target,
     * are asked to swap days.
     */
    RequestTypes["ExchangeDay"] = "EXCHANGE-DAY";
    /**
     * Representing a Request where the Resource wants to
     * plan an absence, which need to be agreed upon.
     */
    RequestTypes["Absence"] = "ABSENCE";
    /**
     * Representing a Request where the Resource wants to
     * change an approved absence, which need to be agreed upon.
     */
    RequestTypes["AbsenceChanged"] = "ABSENCE-CHANGED";
})(RequestTypes || (RequestTypes = {}));
